<template>
  <v-container class="white-wrapper" fluid>
    <!-- <phone-overlay :show="!auth_sms" :back="true"></phone-overlay> -->
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      style="
        max-width: 25rem;
        margin: 0 auto;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      "
      class="px-4"
    >
      <!-- <span class="text-subtitle-2 font-weight-bold">{{
        $t('send.coinLabel')
      }}</span> -->
      <div>
        <v-select
          :items="wallet"
          :placeholder="$t('send.coinPlaceholder')"
          :rules="coinRules"
          v-model="select_coin"
          required
          :label="$t('send.coinLabel')"
        >
          <template slot="selection" slot-scope="{ item }">
            <div class="d-flex select-item justify-space-between px-4">
              <div class="d-flex align-center justify-center">
                <img
                  class="mr-2"
                  style="width: 1.5rem"
                  :src="imgSrc(item.name)"
                />
                <div class="font-weight-black d-flex align-center">
                  {{ item.name }}
                </div>
              </div>
              <div class="font-weight-medium d-flex align-center justify-end">
                {{ comma(item.balance) }}
              </div>
            </div>
          </template>

          <template slot="item" slot-scope="{ item }">
            <div class="d-flex select-item justify-space-between">
              <div class="d-flex align-center justify-center">
                <img
                  class="mr-2"
                  style="width: 1.5rem"
                  :src="imgSrc(item.name)"
                />
                <div class="font-weight-black d-flex align-center">
                  {{ item.name }}
                </div>
              </div>
              <div class="font-weight-medium d-flex align-center justify-end">
                {{ comma(item.balance) }}
              </div>
            </div>
          </template>
        </v-select>

        <!-- <div class="plp-message" v-if="select_coin === 'plp'">
        <div class="plp-amount">
          <span>{{ $t('send.availableAmount') }}</span>
          <span class="black--text">{{ comma(availableCcc) }} PLP</span>
        </div>
        <v-divider class="my-3"></v-divider>
        <div class="plp-link">
          {{ $t('send.pliDesc') }}
        </div>
      </div> -->
        <!-- <span class="text-subtitle-2 font-weight-bold">{{
        $t('send.amountLabel')
      }}</span> -->
        <v-text-field
          :placeholder="$t('send.amountPlaceholder')"
          :label="$t('send.amountLabel')"
          type="number"
          clearable
          v-model="amount"
          :rules="amountRules"
          required
          @keypress="onKeydown"
        ></v-text-field>

        <v-text-field
          :placeholder="$t('send.smsgPlaceholder')"
          :label="$t('send.smsgLabel')"
          type="text"
          clearable
          v-model="smsg"
          :rules="smsgRules" 
          max="5"
          
        ></v-text-field>
        <v-text-field
            :placeholder="$t('send.addressPlaceholder')"
            :label="toAddress_label"
            clearable
            v-model="toAddress"
            required
            :rules="addressRules"
          ></v-text-field> 

        <!-- <span class="text-subtitle-2 font-weight-bold">{{ $t('send.addressLabel')      }}</span> -->
        <div v-show="isFeeUse==true">            


          <!-- <span class="text-subtitle-1">{{ $t('send.feeLabel') }}</span>
          <vue-slider
            class="send-slider"
            v-model="fee"
            :silent="true"
            :min="min"
            :max="max"
            :marks="sliderMarks"
            :interval="step"
            :disabled="!gasInfo"
            :tooltip="'active'"
            :process-style="{
              backgroundColor: 'var(--primary-color)'
            }"
          >
            <template v-slot:tooltip="{ value }">
              <div class="custom-tooltip text-caption">{{ value / 10 }} Gwei</div>
            </template>
          </vue-slider>
          <div
            class="d-flex flex-column align-center"
            style="min-height: 3.4rem"
            cols="12"
          >
            <div class="error-box" v-show="tooLowFee">
              <div class="text-caption error--text">
                {{ $t('send.feeCaution') }}
              </div>
            </div>
          </div> -->

          


          <div class="d-flex justify-space-between ml-auto pb-4">
            <span class="text-subtitle-1">{{ $t('send.expactFee') }}</span>
            <div class="d-flex align-center">
              <!-- <span style="font-weight: bold;">
                {{ $t('send.about') }}
              </span> -->
              <!-- <span class="text-h5 font-weight-bold ml-1"
                >{{ expectFee }} ETH</span -->
                <span class="text-h5 font-weight-bold ml-1"
                >{{ expectFee }} BNB</span

              >
            </div>
            
          </div>          
        </div> 
        <div v-show="isFeeUse!=true" >  <!--  isFeeUse == false  -->
<!--             
            <div class="text-caption error--text" style="padding-top: 30px;;">
                Tron tokens must have sufficient TRX <br/>
                TRX 200 and above
            </div> -->

        </div>

      </div>
        <!-- {{this.select_coin }}//{{  this.ccc }} -->
      <div>
        <v-btn
          class="font-weight-bold mb-4"
          color="primary"
          block
          x-large
          @click="sendAuthCode"
          :disabled="isLoading"
        >
        <!-- openConfirmModal = > sendAuthCode  -->
          <!-- {{ $t('send.send') }} -->
            전송하기
        </v-btn>
      </div>
    </v-form>

    <v-dialog v-model="refreshModal" persistent>
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          {{ $t('send.refreshModal.message') }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-0">
          <v-btn
            color="#AFAFAF"
            width="50%"
            text
            x-large
            class="font-weight-bold"
            to="/home"
          >
            {{ $t('send.refreshModal.home') }}
          </v-btn>
          <v-divider vertical></v-divider>
          <v-btn
            color="primary"
            width="50%"
            text
            x-large
            class="font-weight-bold"
            @click="reload"
          >
            {{ $t('send.refreshModal.reload') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="successModal" max-width="30rem">
      <v-card>
        <div class="d-flex flex-column align-center">
          <div class="mt-5">{{ $t('send.successModal.title') }}</div>
          <div class="text-h6 font-weight-bold my-8">
            {{ $t('send.successModal.desc') }} : {{ success.amount }}
            {{ success.symbol }}
          </div>
        </div>
        <v-divider></v-divider>
        <v-card-actions class="pa-0">
          <v-btn
            color="#AFAFAF"
            width="50%"
            text
            x-large
            @click="successModal = false"
            class="font-weight-bold"
          >
            {{ $t('close') }}
          </v-btn>
          <v-divider vertical></v-divider>
          <v-btn
            color="primary"
            width="50%"
            text
            x-large
            class="font-weight-bold"
            :href="success.href"
            target="_blank"
          >
            {{ $t('send.successModal.confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmModal" persistent max-width="30rem">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <div>{{ $t('send.confirmModal.amount') }}</div>
          <div>{{ amount }} {{ select_coin }}</div>
          <div>{{ $t('send.confirmModal.address') }}</div>
          <div>{{ toAddress }}</div>
          <div>{{ $t('send.confirmModal.message') }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-0">
          <v-btn
            color="#AFAFAF"
            width="50%"
            text
            x-large
            class="font-weight-bold"
            @click="confirmModal = false"
          >
            {{ $t('send.confirmModal.cancel') }}
          </v-btn>
          <v-divider vertical></v-divider>
          <v-btn
            color="error"
            width="50%"
            text
            x-large
            class="font-weight-bold"
            @click="authCheck"
          >
          <!-- 인증팝업 sendAPICall => authCheck  -->
            {{ $t('send.confirmModal.send') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="messageModal" max-width="30rem">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text v-html="message"> </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            width="50%"
            text
            x-large
            @click="messageModal = false"
            class="font-weight-bold"
          >
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="authModal" persistent max-width="30rem">
      <v-card>
        <v-card-title>{{ $t('send.authModal.title') }}</v-card-title>
        <v-card-text>                  
          <div>{{ $t('send.authModal.message') }}</div>
        </v-card-text>


        <v-text-field 
          :placeholder="$t('send.authModal.code')"
          :label="$t('send.authModal.code')"
          type="number"
          style="width:80%;margin:0 auto ; "
          clearable
          v-model="authCode"          
          required          
        ></v-text-field>

        <v-divider></v-divider>
        <v-card-actions class="pa-0">
          <v-btn
            color="#AFAFAF"
            width="50%"
            text
            x-large
            class="font-weight-bold"
            @click="authModal = false"
          >
            {{ $t('send.authModal.cancel') }}
          </v-btn>
          <v-divider vertical></v-divider>
          <v-btn
            color="error"
            width="50%"
            text
            x-large
            class="font-weight-bold"
            @click="authCheck"
          >
            {{ $t('send.authModal.confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import BigNumber from 'bignumber.js'
import PhoneOverlay from '../components/PhoneOverlay.vue'

export default {
  computed: {
    auth_sms() {
      return this.$store.getters.user.auth_sms === 'Y' ? true : false
    },
    myWalletAdress() {
      return this.$store.getters.user.wallet_address
    },
    wallet() {
      return this.$store.getters.wallet.filter((i) => i.name !== 'HLM' && i.name !== 'PGP' && i.name !== 'PCC'
        && i.name !== 'TRX'
        && i.name !== 'W3P' 
        
        && i.name !== 'ETH' 
        && i.name !== 'BNB' 
        && i.name !== 'UMC' 
        && i.name !== 'USDT' 
        && i.name !== 'USDT-TRC' 

        && i.name !== 'EUR'
        && i.name !== 'MATIC'
        && i.name !== 'SOLANA'
        && i.name !== 'STAIKA'
    )},
    isLoading() {
      return this.$store.getters.loading
    },
    tooLowFee() {
      return this.gasInfo && this.fee === this.gasInfo.average
    },
    expectFee() {
      console.log(this.fee)
      // console.log("this.fee : " ,this.fee , BigNumber(this.fee) , BigNumber(this.fee).times(60000).div(10000000000).toNumber()  )
      

      // return this.fee
      //   ? BigNumber(this.fee).times(60000).div(10000000000).toNumber()
      //   : 0
         return this.fee
        ? 0.05
        : 0

    },
    ccc() {
      // console.log(this.$store.getters.wallet.filter((i) => i.name === 'UMC')[0].balance)
      return this.$store.getters.wallet.filter((i) => i.name === 'UMCP')[0]
        .balance
    } ,    

  },
  watch:{
    select_coin(){
      // console.log("select :: " , this.select_coin )
      let hideFeeAry = ['usdt-trc' , 'trx' , 'w3p','hlm','alcp'] ;       
      this.isFeeUse = ( hideFeeAry.includes(this.select_coin) ) ? false :true ;  

      this.toAddress_label = ( this.select_coin == 'alcp')? '핸드폰번호':'지갑주소'  ;

    }

  } ,
  data: () => ({
    valid: true,
    step: 1,
    amount: '',
    smsg:'' , 
    toAddress: '',
    toAddress_label: '핸드폰번호' ,
    // "$t('send.addressLabel')"  this.$i18n.t("send.addressLabel") 
    fee: null,
    average: null,
    min: null,
    max: null,
    gasInfo: null,
    sliderMarks: {},
    isFeeUse: false ,
    select_coin: 'alcp',
    smsgRules: [ (v) => (  v!='' && v.length >= 10) ],  // 송금메모 20글자 이상 
    amountRules: [(v) => !!v || '', (v) => v > 0 || ''],
    addressRules: [
      (v) => !!v || '',
      // (v) => (v && v.length >= 41) || '',
      // (v) => (v && v.startsWith('0x')) || ''
      // (v) => {
      //   console.log( "isFeeUse : "  , this.isFeeUse)
      //   if( this.isFeeUse == true ) {
      //     if( !v.startsWith('0x') ) return false ; 
      //     if( v.length >= 41)  return false ; 
      //   }else{

      //   }
        
      //   return '' ; 
      // }

    ],
    coinRules: [(v) => !!v || ''],
    refreshModal: false,
    successModal: false,
    success: {
      amount: 0,
      href: '',
      symbol: ''
    },
    confirmModal: false,
    messageModal: false,
    authModal : false , 
    authCode : null , 
    authinfo : {} ,     
    message: null,
    availableCcc: 0,
    formatter: (v) => v / 10
  }),
  components: {
    VueSlider,
    PhoneOverlay
  },
  created() {
    this.$store.commit('activeMenu', 'send')

 
    this.$store.dispatch('FETCH_USERINFO')
    this.$store.commit('loading', true)
    // this.$store.dispatch('FETCH_WALLET')
    this.smsgRules = [
      // (v) => (v != '' && v.length >= 100 ) || this.$t('send.smsgRules20length'),
      // console.log( 'smsgRules :: ' ,   v.length )    ,

      (v) => ( v && v.length <= 10 ) || this.$t('send.smsgRules20length'),

    ] 
    this.amountRules = [
      (v) => !!v || this.$t('send.amountRulesRequired'),
      (v) => v > 0 || this.$t('send.amountRulesConfirmed')
    ]
    this.addressRules = [
      (v) => !!v || '',

      // (v) => !!v || this.$t('send.addressRulesRequired'),
      // (v) => (v && v.length >= 41) || this.$t('send.addressRulesConfirmed'),
      // (v) => (v && v.startsWith('0x')) || this.$t('send.addressRulesConfirmed')
    ]
    this.coinRules = [(v) => !!v || this.$t('send.coinRulesRequired')]

    this.$store
      .dispatch('AVAIL_TOKEN', {
        token: 'alc'
      })
      .then((res) => {
        // console.log(res)
        const data = res.data
        const sum = BigNumber(data.locked.sum).plus(data.staking.sum).toNumber()
        // console.log(sum, this.plp.balance)
        this.availableCcc = BigNumber(this.ccc).minus(sum).toNumber()
        // return true
        return this.getGasInfo()
      })
      .then(() => {
        this.$store.commit('loading', false)
      })
    this.getGasInfo().then(() => {
      this.$store.commit('loading', false)
    })
  },
  methods: {
    imgSrc(item) {
      let src
      try {
        src = require(`@/assets/svg/${item + '-logo.svg'}`)
      } catch (e) {
        try {
          src = require(`@/assets/svg/${item + '-logo.png'}`)
        } catch (e) {
          src = require(`@/assets/svg/ETH-logo.svg`)
        }
      }
      return src
    },
    getGasInfo() {
      return this.$store
        .dispatch('GETGAS')
        .then((res) => {
          // console.log( "gasInfo:: " ,  res  )
          console.log( "gasInfo:: " ,  res.data.status )
          //  GasStationAPI Changed:: 
          //  this.gasInfo = res.data
          if( res.data.status  == 1 ) {

              let fast = (res.data.result.SafeGasPrice == res.data.result.FastGasPrice) ? res.data.result.FastGasPrice+0.2: res.data.result.FastGasPrice ; 
              this.gasInfo =  {
                average : parseInt( res.data.result.SafeGasPrice) *10  , 
                //fastest : parseInt( res.data.result.FastGasPrice) *10 ,  
                fastest : parseInt(fast)  *10                
              }  ; 
          }else{              
              this.gasInfo =  {
                average : 0.5 , 
                //fastest : parseInt( res.data.result.FastGasPrice) *10 ,  
                fastest : 0.55                
              }  ; 

          }



          console.log( "gasInfo.average :: " ,  this.gasInfo.average   )
          this.min = this.gasInfo.average
          this.max = this.gasInfo.fastest
          this.average = this.gasInfo.average
          this.fee = this.gasInfo.average

          this.sliderMarks[this.min] = {
            label: this.$t('send.slow')
          }
          this.sliderMarks[this.max] = {
            label: this.$t('send.fast')
          }
          this.sliderMarks[this.average] = {
            label: this.$t('send.average'),
            style: {
              width: '8px',
              height: '8px',
              display: 'block',
              backgroundColor: 'var(--primary-color)',
              transform: 'translate(-2px, -2px)',
              boxShadow: '0px 0px 2px 1px rgb(0 0 0 / 10%)'
            },
            labelStyle: {
              backgroundColor: 'var(--primary-color)',
              color: '#fff',
              padding: '0 0.5rem',
              borderRadius: '1rem'
            }
          }
        })
        .catch((err) => {
          this.refreshModal = true
        })
    },
    reload() {
      window.location.reload()
    },
    openConfirmModal() {
      // this.sendAuthCode();
      if (this.$refs.form.validate()) {
        this.confirmModal = true
      }
    },
    onKeydown(e) {
      if (
        e.keyCode === 101 ||
        e.keyCode === 69 ||
        e.keyCode === 45 ||
        e.keyCode === 43
      )
        e.preventDefault()

      let regx = /^\d*[.]\d{18}$/
      if (this.select_coin === 'usdt') regx = /^\d*[.]\d{6}$/
      const _value = e.target.value

      if (regx.test(_value)) e.preventDefault()
    },
    authCheck(){  
      // this.$store.commit('loading', false)            
      // this.messageModal = true
      // this.message = `${this.$t('send.failMessage')}<br/>(${error})`            
// console.log( this.authinfo.authcode  , this.authCode ) ; 


          if( this.authinfo.authcode ) {

            if( this.authinfo.authcode  ==  this.authCode ) {
              this.authModal = false  ; 
              this.authinfo = {} ; 
              this.authCode = '' ;
              this.sendAPICall(); 
            }else{
              this.authCode = '' ;
              this.$store.commit('loading', false)            
              this.messageModal = true
              this.message = `${this.$t('send.authModal.checkMsg')}`                  
              // checkMsg `Please check your authentication number.`                          
            }

          }else {
            this.$store.commit('loading', false)            
            this.messageModal = true
            this.message = `${this.$t('send.failMessage')}`                
          } ; 

     


    }, 
    sendAuthCode(){
      // sendSms : (location.host.indexOf('localhost') > -1 ||  location.host.indexOf('172') > -1 ) ? false :true 
      this.authinfo = {} ;  
      if (this.$refs.form.validate()) {  
          this.authModal = true ; 

          this.$store.dispatch('authsend',{
            sendSms : (location.host.indexOf('localhost') > -1 ||  location.host.indexOf('172') > -1 ) ? false :true    
          })
          .then((res)=>{ 
            this.authinfo = res.data  ; 
            // console.log("res : " , res , this.authinfo.authcode  ) ;
          }) 
          .catch((err)=>{

              this.$store.commit('loading', false)            
              this.messageModal = true
              this.message = `${this.$t('send.failMessage')}<br/>(${err})`            

          }) ; 
 
      } ; 
      // sendAPICall

    } , 
    sendAPICall() {
 
      this.$store.commit('loading', true)
      this.confirmModal = false

      if (!this.gasInfo) {
        this.$store.commit('loading', false)
        this.$store.dispatch('toast', {
          toast: true,
          toast_msg: this.$t('errorServer'),
          timeout: 3000
        })
      } else {
        this.$store
          .dispatch('FETCH_WALLET')
          .then(() => {
            const params = {
              token: this.select_coin
            }
            return this.$store.dispatch('AVAIL_TOKEN', params)
          })
          .then((res) => {

            console.log("availableCcc :: AVAIL_TOKEN NExt" )
            const data = res.data
            const sum = BigNumber(data.locked.sum)
              .plus(data.staking.sum)
              .toNumber()
            const availableCcc = BigNumber(this.ccc).minus(sum).toNumber()
            console.log("availableCcc :: " , this.select_coin , this.ccc, availableCcc, this.amount)

            if (this.select_coin === 'alcp') {

              if (parseFloat(availableCcc) < parseFloat(this.amount))
                throw 'insufficient'

            } else {

              this.wallet.map((item) => {
                if (
                  this.select_coin === item.value &&
                  parseFloat(item.balance) < parseFloat(this.amount)
                )
                  throw 'insufficient'
              })
            }
            return res
          })
   
          .then(() => {
            const params = {
              amount: this.amount,
              fee: this.fee,
              toAddress: this.toAddress.trim(),
              sendType: this.select_coin , 
              smsg : this.smsg
            } 
            console.log ( "send trans this.select_coin :: " , this.select_coin)  ; 
            if( this.select_coin == 'trx' || this.select_coin == 'usdt-trc' || this.select_coin == 'hlm' ){              
              return this.$store.dispatch('send_transaction_tron', params) ; 
            }else if( this.select_coin == 'alcp' ) {              
              return this.$store.dispatch('send_transaction_w3p', params) ; 
            }else{
              return this.$store.dispatch('send_transaction', params) ; 
            } ; 
            
          })
          .then((res) => { 
            // console.log('res.data', res)
            this.$store.commit('loading', false)

            this.$store.dispatch('FETCH_USERINFO').then(() => {
              this.$store.dispatch('FETCH_WALLET')
            })

            if (res.data.status) {
              this.success.amount = this.amount
              this.success.href = ( this.isFeeUse == true) ? `https://etherscan.io/tx/${res.data.hash}`:`https://tronscan.org/#/transaction/${res.data.hash}`
              this.success.symbol = this.select_coin.toUpperCase()
              if( this.success.symbol == 'UMCP') {
                this.success.href = '/#/config/history/point' ; 
              } ;           

              
              this.successModal = true
            } else if (res.data.error.indexOf('insufficient') !== -1) {
                this.messageModal = true
                this.message = this.$t('send.insufficientMessage') 

            } else if (res.data.error.indexOf('Unable to confirm target') !== -1) {
                this.messageModal = true
                this.message =  "전송대상을 찾을수 없습니다.";               
                
            } else {
                this.messageModal = true
                this.message = `${this.$t('send.failMessage')}<br/>(${
                res.data.error
              })`
            }

            this.$refs.form.reset()
            this.fee = this.average
          })
          .catch((error) => {
            // console.log(error) 
            this.$store.commit('loading', false)
            if (error === 'insufficient') {
              this.messageModal = true
              this.message = this.$t('send.insufficientMessage')
            } else {
              this.messageModal = true
              this.message = `${this.$t('send.failMessage')}<br/>(${error})`
            }

            this.$refs.form.reset()
            this.fee = this.average
          })
      }
    }
  }
}
</script>

<style scoped>
.label {
  display: flex;
  align-items: center;
}
.label::before {
  content: '';
  display: inline-block;
  margin-right: 0.3rem;
  width: 0.4rem;
  height: 1rem;
  background-color: var(--primary-color);
}
.select-item .col {
  padding: 0 1rem;
}
.select-item {
  width: 100%;
  color: #121212;
}
.send-slider {
  z-index: 1 !important;
  margin: 1rem;
}
.error-box {
  text-align: center;
  /* background-color: #ffdcdc; */
  border-radius: 4px;
  padding: 0.2rem;
  width: 100%;
  max-width: 19rem;
  margin-top: 0.8rem;
}
.vue-slider-dot-handle {
  box-shadow: 0px 0px 1px 2px rgb(62 11 165 / 32%);
}
.send-link {
  font-size: 1.3rem;
  font-weight: bold;
}
.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #dadada !important;
  color: #888888 !important;
}
.plp-message {
  color: #939393;
  padding: 0 0.7rem;
}
.plp-amount {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  font-size: 0.9rem;
}
.plp-link {
  font-size: 0.8rem;
}
.plp-link a {
  color: #4270d5;
  font-weight: bold;
  text-decoration: underline;
}
.custom-tooltip:after {
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
  height: 0;
  width: 0;
  content: '';
  position: absolute;
  top: 100%;
  border-color: transparent;
  border-style: solid;
  border-width: 5px;
  border-top-color: inherit;
}
.custom-tooltip {
  font-size: 14px;
  white-space: nowrap;
  padding: 2px 5px;
  min-width: 20px;
  text-align: center;
  color: #fff;
  border-radius: 5px;
  border-color: var(--primary-color);
  background-color: var(--primary-color);
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}
</style>
